import classNames from 'classnames';
import React from 'react';
import Icon from '@material-ui/core/Icon';
import Button from '../Button';
import { RefObject } from 'react';

export interface TextboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;

  /**
   * テキスト
   */
  value?: string;

  /**
   * アイコンがある場合、ラッパーのdivに追加するクラス名
   */
  wrapperClass?: string;

  /**
   * 無効かどうか
   */
  disabled?: boolean;

  /**
   * 読み取り専用かどうか
   */
  isReadonly?: boolean;

  /**
   * エラー
   */
  error?: boolean;

  /**
   * 有効な値
   */
  valid?: boolean;

  /**
   * 左側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  leftIcon?: string;

  /**
   * 右側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  rightIcon?: string;

  /**
   * ボタンとしてのアイコン
   */
  buttonIcon?: string;

  /**
   * ボタンを押した時のアクション
   */
  onClickIcon?: (e: React.MouseEvent<HTMLElement>) => any;

  /**
   * 横幅
   */
  width?: "3s" | "2s" | "s" | "m" | "ml" | "l" | "2l" | "full";
  /**
   * 高さ
   */
  height?: "s" | "m" | "l" | "2l" | "3l";

  /**
   * 角丸
   */
  isRound?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
}

const Textbox: React.FC<TextboxProps> = ({
  className,
  wrapperClass,
  value = "",
  disabled = false,
  isReadonly = false,
  error = false,
  valid = false,
  leftIcon,
  rightIcon,
  buttonIcon,
  onClickIcon,
  width,
  height,
  isRound = false,
  inputRef,
  ...props
}) => {
  const classes = classNames(
    "uc-textbox",
    className,
    width && `uc-textbox--w${width === "full" ? "-" : ""}${width}`,
    height && `uc-textbox--h${height}`,
    disabled && "uc-textbox--disabled",
    isReadonly && "uc-textbox--readonly",
    error && "uc-textbox--error",
    valid && "uc-textbox--success",
    isRound && "uc-textbox--round"
  )

  const renderTextBox = <input
    value={value}
    type="text"
    className={classes}
    disabled={disabled || isReadonly}
    ref={inputRef}
    {...props} />

  const hasIcon = leftIcon || rightIcon || buttonIcon;

  return hasIcon ?
    <div
      className={classNames(
        "uc-icon-textbox",
        `uc-icon-textbox--has${leftIcon ? "-left" : ""}${(rightIcon || buttonIcon) ? "-right" : ""}-icon`,
        wrapperClass,
      )}
    >
      {leftIcon && <Icon className="uc-icon-textbox__icon uc-icon-textbox__icon--left">{leftIcon}</Icon>}
      {renderTextBox}
      {rightIcon && <Icon className="uc-icon-textbox__icon uc-icon-textbox__icon--right">{rightIcon}</Icon>}
      {buttonIcon &&
        <Button
          leftIcon={buttonIcon}
          className="uc-icon-textbox__icon-button uc-icon-textbox__icon-button--right"
          disabled={disabled}
          onClick={onClickIcon} />}
    </div> :
    renderTextBox
};

export default Textbox;